<template>
  <div class="kwMenu nav_right_items">
    <div v-for="(parentItem,parentIndex) in menuList" :key="'block_kb_'+parentIndex">
      <!--当前项的id等于item项的id，那个就是当前状态-->
      <!--用data-index记录这个数据在数组的下标位置，使用data-id设置每个item的id值，供打开2级页面使用-->
      <!-- active open -->
      <div class="nav_left_items ">
        {{parentItem.menuName}}
      </div>
      <el-row>
        <template v-for="(childItem,childIndex) in parentItem.meunColl">
          <el-col  :key="'child_menu_'+childIndex" :span="6" style="text-align:center;margin: 5px 0;" v-if="(childItem.pageId != -1)" @click.native="listDataClick(childItem)" >
            <!--用div包裹图片组合，如果有图片就用，无图片提供就使用50x30的这个默认图片-->
            <div :class="'imgBox'+ (' imgBoxbc_'+(parentIndex%3))">
              <template v-if="(childItem.menuImage)">
                <img :src="GLOBAL.getFileServeUrl()+childItem.menuImage" mode='aspectFit'/>
              </template>
              <template wx:else>
                <img :src="require('./images/menu_'+(Math.ceil(Math.random()*10))+'.png')" mode='aspectFit'/>
              </template>
            </div>
            <!--如果有文字，就用文字；无文字就用其他-->
            <div class='textBox text_content'>
              <span>{{childItem.menuName}}</span>
            </div>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kwMenu',
  props: {
    msg: String
  },
  data() {
    return {
      loginInfo:{},
    };
  },
  created() {
    var that = this;
    //把登陆时获取的菜单按钮 赋值给本页面的变量
    //进行栏目菜单层级合并 保证只有两级菜单
    var menuListStr = localStorage.menuList;
    var menuList;
    if (utils.isNotNull(menuListStr)) {
      menuList = JSON.parse(menuListStr);
    }
    console.log("menuList=========================",menuList);
    var finalMenuList = [];
    var noChildMenu = {menuName:"其他",meunColl:[]};
    menuList.forEach(parent => {
      // if(!parent.meunColl) {
        that.initMenuList(parent,finalMenuList,noChildMenu);
      // } else {
      //   finalMenuList.push(parent);
      // }
    });
    if(noChildMenu.meunColl.length > 0) {
      finalMenuList.push(noChildMenu);
    }
    console.log("finalMenuList=================",finalMenuList);
    that.menuList = finalMenuList; 
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    initMenuList:function(menuParent,finalMenuList,noChildMenu){
      var that = this;
      var childMenuList = [];
      //子级是否有能点击的 如果有 则把父级加入到最终里边
      if(menuParent.meunColl) {
        menuParent.meunColl.forEach(child => {
          if(child.pageId > 0) {
            childMenuList.push(child);
          } else {
            that.initMenuList(child,finalMenuList,null);
          }
        });
      }
      if(childMenuList.length>0) {
        menuParent.meunColl = childMenuList;
        finalMenuList.push(menuParent);
      } else if(noChildMenu != null){
        noChildMenu.meunColl.push(menuParent);
      }
    },
    listDataClick:function(pageInfo){ 
      var that = this;
      if(pageInfo.actionWay ==2) {
        // 跳转列表页面
        var toListJson = {
            pageId: pageInfo.pageId,
            tableId: pageInfo.tableId,
            callBackType: 0,
            openWay:1,
            menuName:pageInfo.menuName
        }
        if(utils.isNotNull(localStorage.loginInfo)) {
          that.loginInfo = JSON.parse(localStorage.loginInfo);
          toListJson.mainId = this.loginInfo.USERID;
        }
        pageUtils.toNewLookPage(that,toListJson);
      } else {
        if(pageInfo.pageId > 0) {
          var toListJson = {
              pageId: pageInfo.pageId,
              tableId: pageInfo.tableId,
              initCheckId: 0,
              callBackType: 0,
              dataMaxNum: 1,
              isLimitButton:true
          }
          pageUtils.toNewListPage(this,toListJson);
        }
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navBox{height: 100%;overflow: hidden;background: #f3f7ff;color: #858585;}
.navBox span{color: #000;}
.navTitle{float: left;width: 125px;height: 39px;line-height: 39px;text-align: center;color: #7c8804;font-size: 17px;}
/*左侧*/
/*.nav_left{position: absolute;top: 0;bottom: 0;left: 0;width: 7rem;border: 1px solid #e6e6e6;border-width: 0 1px 0 0;background: #fff;overflow: auto;-webkit-overflow-scrolling: touch;}*/
.nav_left{width: 100%;background: #fff;overflow: auto;-webkit-overflow-scrolling: touch;padding: 0 10px 0 0}
.nav_left_items{font-size: 15px;font-family: PingFang SC;font-weight: bold;color: #000000;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;border-left: 2.5px solid #006BB9;padding: 0 0 0 3px;margin:15px 0 10px 0;}
.nav_left_items.open{color: #F02A2B;border-bottom: 2px solid #F02A2B}



/*右侧*/
/*标题*/
.nav_system_title{font-size:16px;color:#000;text-align:left;}
/*.nav_right{display: block;height: 100%;margin-left: 6.8rem;padding-top: 6px;overflow: auto;-webkit-overflow-scrolling: touch; text-align:center;}*/
.nav_right{display: block;height: 100%;padding:10px 0 10px 10px;overflow: auto;-webkit-overflow-scrolling: touch; text-align:center;background: #fff}
.nav_right_Con{display:flex;flex-wrap:wrap;}
.navRightBar{float: left;width: 100%;line-height: 1em;padding: 15px 0;color: #333;}
/*单内容*/
/*.nav_right_items{display: inline-block; float: left; width: 6rem;height: auto;background: #fff; margin: 1rem 0 0.5rem 1rem; padding: .8rem .1em .1em .1em;box-sizing: border-box; overflow:hidden;}*/
.nav_right_items{}
/*图片*/
.nav_right_items .imgBox{text-align: center;width:40px;height:40px;background: #006BB9;
border-radius: 10px;margin: 0 auto;}
.nav_right_items .imgBoxbc_0{background: #006BB9;}
.nav_right_items .imgBoxbc_1{background: #00AFB1;}
.nav_right_items .imgBoxbc_2{background: #E8A400;}
.nav_right_items .imgBox img{width: 15px;height: 19px;margin: 10px 0;}
/*文字*/
.nav_right_items .textBox{display: flex;text-align: center;font-size: 12px;white-space: normal;height: 1.6rem;margin:8px 0;height: 15px;line-height: 15px;}
.nav_right_items .textBox span{display: block; margin: auto;}

.icon-left:before { content: "\e623"; }

.text_content{
  width: 100%;
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
}
</style>
